import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  getCarRateRulesRequest,
  getCarRateRulesSuccess,
} from '../../slices/car';

const queryString = require('query-string');

function* getCarRateRulesWorker({
  payload: {
    itinerary,
  },
}) {
  try {
    const { currencyCode } = yield select((store) => store.tripSearch);
    const { matchingMembershipCodes } = itinerary.priceInfo;
    const url = `/rentalcars/getCarRateRules?${queryString.stringify({
      pickupDateTime: itinerary.pickUpDateTime,
      returnDateTime: itinerary.dropOffDateTime,
      SIPP: itinerary.carDetails.vehicleType,
      bookingProviderCode: itinerary.bookingProviderInfo.bookingProviderCode,
      originLocationCode: itinerary.locationInfo.originLocationCode,
      originLocationExtendedCode: itinerary.locationInfo.originLocationExtendedCode,
      destLocationCode: itinerary.locationInfo.destLocationCode,
      destLocationExtendedCode: itinerary.locationInfo.destLocationExtendedCode,
      rateCode: itinerary.priceInfo.rateCode,
      currencyCode: itinerary.priceInfo.currencyCode || currencyCode,
      rateCodes: matchingMembershipCodes && matchingMembershipCodes.length > 0
        ? matchingMembershipCodes : undefined,
    })}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(getCarRateRulesSuccess({ key: itinerary.uniqueKey, vendorMessages: data }));
    } else {
      yield put(getCarRateRulesSuccess({ key: itinerary.uniqueKey, vendorMessages: {} }));
    }
  } catch (error) {
    yield put(getCarRateRulesSuccess({ key: itinerary.uniqueKey, vendorMessages: {} }));
  }
}

function* getCarRateRulesWatcher() {
  yield takeEvery(getCarRateRulesRequest.toString(), getCarRateRulesWorker);
}

export default getCarRateRulesWatcher;
